import React from "react";
import { motion } from "framer-motion";

export function SkeletonBlock({ height = 16, width = "100%", radius = 6, style = {} }) {
  return (
    <motion.div
      className="pm-skeleton"
      style={{ height, width, borderRadius: radius, ...style }}
      animate={{ opacity: [0.5, 1, 0.5] }}
      transition={{ repeat: Infinity, duration: 1.4, ease: "easeInOut" }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="pm-card pm-skeleton-card">
      <SkeletonBlock height={14} width="40%" />
      <SkeletonBlock height={28} width="60%" style={{ marginTop: 12 }} />
      <SkeletonBlock height={12} width="80%" style={{ marginTop: 16 }} />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <tr className="pm-skeleton-row">
      <td colSpan={9}>
        <SkeletonBlock height={18} />
      </td>
    </tr>
  );
}
